export default {
	name: "ex-tank-order-management",
	props:{
		companyId:{
			default: null
		}
	},
	data() {
		return {
			orders: [],
			orderStatuses: [],
			orderTypes: [],
			customers: [],
			exTankOrderHeadings: [
				{
					text: "Order #",
					field: "orderId"
				},
				{
					text: "Customer",
					field: "registeredCompanyName"
				},
				{
					text: "Order Date",
					field: "insertedOn"
				},
				{
					text: "Expected Upliftment Date",
					field: "expectedUpliftmentDate"
				},
				{
					text: "Transporter",
					field: "transporter"
				},
				{
					text: "Vehicle Make",
					field: "vehicleMake"
				},
				{
					text: "Vehicle Registration",
					field: "vehicleRegistration"
				},
				{
					text: "Customer Purchase Order Number",
					field: "customerPurchaseOrder"
				},
				{
					text: "SBO",
					field: "sbo"
				},
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Quantity",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Terminal",
					field: "terminal"
				},
				{
					text: "Uplifted Date",
					field: "upliftedDate"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				{
					text: "Status",
					field: "orderStatus"
				}
			],
			apiLoaded:{
				customersLoaded: false,
				orderStatusesLoaded: false,
				orderTypesLoaded: false
			},
			actions: [],
			actionKeys:{
				viewOrder: "viewOrder",
				reviewOrder: "reviewOrder",
				viewTrackingHistory: "viewTrackingHistory",
				completeReview: "completeReview",
				cancel: "cancel",
				documents: "documents",
				completeOrder: "completeOrder",
				orderEnquiries: "orderEnquiries",
				viewAudit: "viewAudit"
			},
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			orderAuditModal:{
				showModal: false,
				modalId: "orderAuditModal",
				heading: "Order Audit",
				orderId: null
			},
			selectOrderTypeModal:{
				modalId: "selectOrderTypeForNewOrderModal",
				heading: "Select Customer for New Ex-tank Order",
				showModal: false
			},
			orderForExTankModal: {
				modalId: "createOrderForExTankModal",
				heading: "Create New Order For Ex-Tank",
				showModal: false,
				companyId: null,
				company: {}
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null,
				orderTypeId: null,
                orderStatusId: null,
			},
			filterStateChanged: false,
			showExpectedDateOfDeliveryFilter: true,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: null,
				companyId: null,
				orderStatusId: null,
				expectedUpliftmentDateToDate: null,
				expectedUpliftmentFromDate: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			loading: false,
			cancelOrderModalId: "cancelOrderModal",
			selectedOrder: {}
		};
	},
	methods: {
		getExTankOrders(){
			this.loading = true;
			this.filter.orderTypeId = orderHelper.orderType.exTank;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				companyId: this.filter.companyId,
				orderStatusId: this.filter.orderStatusId,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				fromDateExpectedUpliftment: this.filter.expectedUpliftmentFromDate,
				toDateExpectedUpliftment: this.filter.expectedUpliftmentDateToDate
			};
			exTankService.getExTankOrders(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orders = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.orders.length; i++){
							this.orders[i].upliftedDate = null;
							if(this.orders[i].discountedAmount !== null){
								this.orders[i].totalAmount = this.orders[i].totalAmount - this.orders[i].discountedAmount;
							}
							// if(this.orders[i].orderTypeId === orderHelper.orderType.delivery){
							// 	this.orders[i].orderType = "Delivery";
							// }
							this.orders[i].totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orders[i].totalAmount);
							this.orders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnOrdersViewOrder"
								},
								{
									name: "View Tracking History",
									key: this.actionKeys.viewTrackingHistory,
									elementId: "btnOrdersViewTrackingHistory"
								},
								{
									name: "Order Enquiries",
									key: this.actionKeys.orderEnquiries,
									elementId: "btnOrdersOrderEnquiries"
								},
								{
									name: "View Audit",
									key: this.actionKeys.viewAudit,
									elementId: "btnOrdersViewAudit"
								}
							];
							switch (this.orders[i].orderStatusId){
								case orderHelper.orderStatus.pending:
									this.orders[i].actions.push(
										{
											name: "Review Order",
											key: this.actionKeys.reviewOrder,
											elementId: "btnOrdersReviewOrders"
										}
									);
									this.orders[i].actions.push(
										{
											name: "Cancel",
											key: this.actionKeys.cancel,
											elementId: "btnOrdersCancelOrder"
										}
									);
									break;
								case orderHelper.orderStatus.accepted:
									this.orders[i].actions.push(
										{
											name: "Complete Review",
											key: this.actionKeys.completeReview,
											elementId: "btnOrdersCompleteReview"
										}
									);
									this.orders[i].actions.push(
										{
											name: "Cancel",
											key: this.actionKeys.cancel,
											elementId: "btnOrdersCancelOrder"
										}
									);
									break;
								case orderHelper.orderStatus.rejected:
									this.orders[i].actions.push(
										{
											name: "Cancel",
											key: this.actionKeys.cancel,
											elementId: "btnOrdersCancelOrder"
										}
									);
									break;
								case orderHelper.orderStatus.readyForUpliftment:
									this.orders[i].actions.push(
										{
											name: "Documents",
											key: this.actionKeys.documents,
											elementId: "btnOrdersViewDocuments"
										}
									);
									this.orders[i].actions.push(
										{
											name: "Cancel",
											key: this.actionKeys.cancel,
											elementId: "btnOrdersCancelOrder"
										}
									);
									break;
								case orderHelper.orderStatus.uplifted:
									this.orders[i].actions.push(
										{
											name: "Documents",
											key: this.actionKeys.documents,
											elementId: "btnOrdersViewDocuments"
										}
									);
									this.orders[i].actions.push(
										{
											name: "Complete Order",
											key: this.actionKeys.completeOrder,
											elementId: "btnOrdersCompleteOrder"
										}
									);
									this.orders[i].upliftedDate = this.orders[i].statusLastUpdatedOn;
									break;
								case orderHelper.orderStatus.complete:
									this.orders[i].actions.push(
										{
											name: "Documents",
											key: this.actionKeys.documents,
											elementId: "btnOrdersViewDocuments"
										}
									);
									this.orders[i].upliftedDate = this.orders[i].statusLastUpdatedOn;
									break;
                                case orderHelper.orderStatus.pendingInvoice:
                                    this.orders[i].actions.push(
                                        {
                                            name: "Documents",
                                            key: this.actionKeys.documents,
                                            elementId: "btnOrdersViewDocuments"
                                        }
                                    );
                                    break;
							}
						}
						this.orders = dataTableHelper.castFieldValues(this.orders);
						this.filterStateChanged = false;
						permissionsHelper.setControlsBasedOnPermissions();
						let self = this;
						setTimeout(function (){
							self.firstLoad = true;
						}, 500);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderStatuses(){
			this.firstLoad = false;
			console.log("order type", this.filter.orderTypeId);
			this.orderStatuses = orderService.getExTankOrderStatuses();
			//this.orderStatuses = orderService.getOrderStatuses();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({
				id: 0,
				text: "All"
			});
			this.filter.orderStatusId = 0;
			this.apiLoaded.orderStatusesLoaded = true;
			if(this.apiLoaded.orderTypesLoaded && this.apiLoaded.customersLoaded){
				this.firstLoad = false;
			}
			console.log("orderStatuses", this.orderStatuses);
		},
		getCustomers(){
			let request = {
				isActive: true,
				pageNumber: 1,
				pageSize: 100000,
				isExTankCompany: true
			};
			this.firstLoad = false;
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customers = successResponse.data.result;
						this.customers = dataTableHelper.castFieldValues(this.customers);
						this.customers.unshift({
							companyId: 0,
							registeredCompanyName: "All"
						});
						this.customers = $.map(this.customers,
							function (obj) {
								obj.id = obj.id || obj.companyId;
								obj.text = obj.text || obj.registeredCompanyName;
								return obj;
							});
						if(this.companyId === null || this.companyId === ""){
							this.filter.companyId = this.customers[0].companyId;
						}
						else{
							this.filter.companyId = this.companyId;
						}
						this.apiLoaded.customersLoaded = true;
						this.getExTankOrders();
						this.getOrderStatuses();

						console.log("companyId", this.filter.companyId);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getExTankOrders();
		},
		onFilterSearchClicked(){
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getExTankOrders();
		},
		onCustomerFilterSelect(customer){
			this.filter.companyId = customer.id;
			console.log("firstLoad", this.firstLoad)
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onOrderStatusSelect(orderStatus){
			this.filter.orderStatusId = orderStatus.id;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onDateFilterClearClick(){
			console.log("clear clicked");
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
			console.log("filter", this.filter);
		},
		onExpectedUpliftmentFilterClearClick(){
			this.filter.expectedUpliftmentFromDate = null;
			this.filter.expectedUpliftmentDateToDate = null;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onExpectedUpliftmentFromDateSelect(date){
			this.filter.expectedUpliftmentFromDate = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onExpectedUpliftmentToDateSelect(date){
			this.filter.expectedUpliftmentDateToDate = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		
		onAddOrderClick(){
			this.selectOrderTypeModal.showModal = true;
		},
		exportOrdersToExcel(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				companyId: this.filter.companyId,
				orderStatusId: this.filter.orderStatusId,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				fromDateExpectedUpliftment: this.filter.expectedUpliftmentFromDate,
				toDateExpectedUpliftment: this.filter.expectedUpliftmentDateToDate
			};
			exTankService.getExTankOrdersAsExcelDocument(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'ExTank Orders.xlsx');
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		onOrderAuditOkButtonClicked(){
			this.orderAuditModal.showModal = false;
		},
		onOrderActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.viewOrder:
					this.$router.push("/orders/extank/viewOrder/" + actionAndData.data.orderExTankId + "/" + actionAndData.data.orderId);
					break;
				case this.actionKeys.reviewOrder:
					this.$router.push("/orders/extank/reviewOrder/" + actionAndData.data.orderExTankId + "/" + actionAndData.data.orderId);
					break;
				case this.actionKeys.viewTrackingHistory:
					this.trackingHistoryModal.showModal = true;
					this.trackingHistoryModal.orderId = actionAndData.data.orderId;
					this.trackingHistoryModal.heading = "Tracking History - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					break;
				case this.actionKeys.viewAudit:
					this.orderAuditModal.showModal = true;
					this.orderAuditModal.orderId = actionAndData.data.orderId;
					this.orderAuditModal.heading = "Order Audit - #" + actionAndData.data.orderId;
				break;				case this.actionKeys.documents:
					this.documentsModal.showModal = true;
					this.documentsModal.orderId = actionAndData.data.orderId;
					this.documentsModal.heading = "Order Documents - #" + actionAndData.data.orderId;
                    this.documentsModal.orderStatusId = actionAndData.data.orderStatusId;
					this.documentsModal.orderTypeId = orderHelper.orderType.exTank;
					break;
				case this.actionKeys.completeReview:
					this.$router.push("/orders/extank/reviewOrder/" + actionAndData.data.orderExTankId + "/" + actionAndData.data.orderId);
					break;
				case this.actionKeys.completeOrder:
					this.$router.push("/orders/extank/completeOrder/" + actionAndData.data.orderExTankId + "/" + actionAndData.data.orderId);
					break;
				case this.actionKeys.cancel:
					this.selectedOrder = actionAndData.data;
					$("#" + this.cancelOrderModalId).modal("show");
					break;
				case this.actionKeys.orderEnquiries:
					this.$router.push("/orders/orderEnquiryMessages/" + actionAndData.data.orderId + "/" + actionAndData.data.companyId + "/" + orderHelper.orderType.exTank + "/" + actionAndData.data.orderStatusId);
					break;
			}
		},
		onCancelYesClick(){
			this.loading = true;
			let request = {
				orderId: this.selectedOrder.orderId,
				companyId: this.selectedOrder.companyId
			};
			orderService.cancelOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getExTankOrders();
					}
					this.selectedOrder = {};
					$("#" + this.cancelOrderModalId).modal("hide");
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					this.selectedOrder = {};
					$("#" + this.cancelOrderModalId).modal("hide");
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onSelectOrderTypeModalCancelClicked(){
			this.selectOrderTypeModal.showModal = false;
		},
		onPlaceOrder(orderToPlace){
			this.selectOrderTypeModal.showModal = false;
			let self = this;
			setTimeout(function (){
				self.orderForExTankModal.showModal = true;
				self.orderForExTankModal.company = orderToPlace.company;
				// if(orderToPlace.orderTypeId === orderHelper.orderType.delivery){
				// 	//self.orderForDeliveryModal.companyId = orderToPlace.companyId;
				// 	//self.orderForDeliveryModal.showModal = true;
				// 	self.shippingAddressSelectModal.showModal = true;
				// 	self.shippingAddressSelectModal.company = orderToPlace.company;
				// 	self.orderToPlace = orderToPlace;
				// }
				// if(orderToPlace.orderTypeId === orderHelper.orderType.collection){
				// 	// TODO: create modal for collection orders
				// 	self.orderForCollectionModal.companyId = orderToPlace.companyId;
				// 	self.orderForCollectionModal.showModal = true;
				// 	self.orderForCollectionModal.company = orderToPlace.company;
				// 	self.orderToPlace = orderToPlace;
				// }
			}, 500);
			console.log("company", orderToPlace.company);
		},
		onPlaceOrderOkClicked(){
			this.orderForExTankModal.showModal = false;
			this.getExTankOrders();
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
			this.getExTankOrders();
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Ex-Tank Orders");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Ex-Tank Orders");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getCustomers();
	}
};